import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  selectLoadingTarget,
  selectPermissions,
  selectPermissionsError,
} from './permissions.selectors';
import { getTargetPermissions } from './permissions.actions';
import { map } from 'rxjs/operators';

export type PermissionsTarget = 'Entities' | 'Locations';

@Injectable()
export class PermissionsFacade {
  loadingTarget$: Observable<string | null> = this.store.select(
    selectLoadingTarget
  );
  permissions$ = this.store.select(selectPermissions).pipe(
    map((permissions) => {
      if (!permissions) return { entity: [], location: [] };

      return {
        entity: permissions["Entities"]?.permissions || [],
        location: permissions['Locations']?.permissions || [],
      };
    })
  );

  error$ = this.store.select(selectPermissionsError);

  constructor(private store: Store) {
    this.dispatchGetPermissionsForTarget('Entities');
  }

  dispatchGetPermissionsForTarget(target: PermissionsTarget) {
    this.store.dispatch(getTargetPermissions({ payload: target }));
  }
}
